var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mensagens.length)?_c('div',_vm._l((_vm.mensagens),function(mensagens,index){return _c('div',{key:index},[_c('b-alert',{attrs:{"show":"","variant":"success","dismissible":""}},[_c('b-icon',{attrs:{"variant":"success","icon":"check"}}),_vm._v(" "+_vm._s(mensagens)+" ")],1)],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }